import { PhoneEffects } from './phone.effects';

export const effects = [ 
    PhoneEffects,
]